import type { FC, ReactElement } from 'react';

import type { L10nTextProps } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '../../../styles/hooks/useModifiers';
import { useSubtitlesViewport } from '../hooks/useSubtitlesViewport';
import styles from '../SubtitlesNew.module.css';
import type { SubtitlesSize } from '../types';

export interface SubtitlesPreviewProps {
  sizes: SubtitlesSize;
  subtitle: ReactElement<L10nTextProps>;
}

export const SubtitlesPreview: FC<SubtitlesPreviewProps> = ({ sizes, subtitle }): ReactElement => {
  const { deviceType } = useSubtitlesViewport();
  const deviceSize = sizes[deviceType];

  const mods = useModifiers(
    styles,
    'subtitles',
    { preview: true },
    {
      additionalModifiers: [deviceSize.toString()],
      withBaseClass: true,
    }
  );

  return (
    <div className={mods}>
      <div className={styles.subtitles__container}>
        <div className={styles.subtitles__content}>
          <div className={styles.subtitles__text}>{subtitle}</div>
        </div>
      </div>
    </div>
  );
};
